import React from 'react';
import 'stylesheets/components/shared-required-legend.scss';

const RequiredLegend = () => (
  <legend
    className="shared-required-legend"
    aria-label="All fields marked 'required' must be completed."
  />
);

export default RequiredLegend;
